export const toggleNotificationSelection = (
  selectedIds: ReadonlySet<string>,
  id: string,
): Set<string> => {
  const next = new Set(selectedIds);
  if (next.has(id)) next.delete(id);
  else next.add(id);
  return next;
};

export const setVisibleNotificationsSelected = (
  selectedIds: ReadonlySet<string>,
  visibleIds: readonly string[],
  selected: boolean,
): Set<string> => {
  const next = new Set(selectedIds);
  visibleIds.forEach(id => {
    if (selected) next.add(id);
    else next.delete(id);
  });
  return next;
};
